import { gql } from '@urql/core';
import { format } from 'date-fns';
import React from 'react';
import { buildFileUrlOrNull } from '../../../client/images.utils';
import { EventHeaderFragment } from '../../../generated/spin-graphql';
import { BackgroundImage } from '../../backgrounds/FadedBackgroundImage';
import { SpinAppModals, useModals } from '../../common/SpinModalProvider';
import { EventGames } from './EventGames';

gql`
    fragment EventHeader on espin_event {
        name
        event_start_date
        prize
        event_end_date
        logo {
            ...SpinContentImageDisplay
        }
        icon {
            ...SpinContentImageDisplay
        }
        type
        event_games {
            ...EventGames
        }
    }
`;

type Props = {
    className?: string;
    eventData: EventHeaderFragment;
};

export const EventHeader: React.FC<Props> = ({ className, eventData }) => {
    const image = buildFileUrlOrNull(eventData.logo);
    const iconUrl = buildFileUrlOrNull(eventData.icon);
    const { openModal, closeActiveModal } = useModals();

    const formatter = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    });
    const prizePool: string | null = eventData.prize ? formatter.format(eventData.prize) : null;

    // TODO @anyone - setup add to calendar button state / functionality
    // Todo - ask Kyle about calendar - may need to be coming soon
    return (
        <div className={`event-header${className ? ` ${className}` : ''}`}>
            <BackgroundImage imageSrc={image} altText={`${eventData.name}`} />
            <div className="container event-info-container">
                <h1 className="title">{eventData.name}</h1>
                <div className="date">
                    {format(new Date(eventData.event_start_date), 'cccc MMMM do')}
                    {' - '}
                    {format(new Date(eventData.event_end_date), 'cccc MMMM do')}
                </div>
                <button
                    className="button medium-button blue-button"
                    onClick={() => {
                        openModal(SpinAppModals.COMING_SOON, { onCancel: closeActiveModal });
                    }}
                >
                    Add to Calendar
                </button>
                <EventGames games={eventData.event_games} />
                {eventData.prize > 0 && (
                    <div className="prize-pool">
                        <p className="prize-label">Prize Pool</p>
                        <p className="prize-value">{prizePool}</p>
                    </div>
                )}
            </div>
        </div>
    );
};
